import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahl } from './DatenauswertungJahrauswahl';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { fn0nZ } from '../../core/formatter/formatNumber';
import { formatNumber } from '../../core/formatter/formatNumber';
import { getRoutingEnergiedaten } from '../../helpers/getRoutingEnergiedaten';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { getStyle } from './generisch/DatanauswertungGenerischStyles';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { rowHasValues } from './generisch/renderRows';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { Validierung } from './elements/Validierung';
import { ValidierungHinweise } from './elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DatenauswertungBWLProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortTid: number;
    standortName: string;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungBWLState {
    pdfString?: string;
    firstJahr: number;
    lastJahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
    validation: any;
}

export class DatenauswertungBWL extends React.Component<DatenauswertungBWLProps, DatenauswertungBWLState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            lastJahr: this.props.jahrLast || jahrMax - 1,
            firstJahr: this.props.jahrFirst || jahrMin,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined,
            validation: {}
        };
    }

    private entities: any[] = [
        { titel: i18n('Betriebsdaten', 'sys'), entity: IDs.ENT_BETRIEBSDATEN }
    ];

    componentDidMount(): void {
        this.setState({
            validation: new Validierung(
                this.props.data,
                this.props.standortTid,
                this.entities,
                'jahr'
            ).getData()
        });
    }

    getValues(): any {
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const custom_row_classes: any[] = [];
        const row_web_forced: boolean[] = [];
        const kennzahlen = this.props.standortTid
            ? this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            : this.props.data[IDs.KENNZIFFERN_BERECHNET];
        const isCfm: boolean = (this.props.data || {}).MODUL_SELECTED === 'cfm';

        for (let jahr = this.state.firstJahr; jahr <= this.state.lastJahr; jahr++) {
            const beheizte_flaeche = kennzahlen[jahr] && kennzahlen[jahr].beheizte_flaeche
                ? kennzahlen[jahr].beheizte_flaeche
                : 0;
            const mitarbeiter = kennzahlen[jahr] && kennzahlen[jahr].mitarbeiter
                ? kennzahlen[jahr].mitarbeiter
                : 0;
            const umsatz = kennzahlen[jahr] && kennzahlen[jahr].umsatz
                ? kennzahlen[jahr].umsatz
                : 0;
            const auslastung = kennzahlen[jahr] && kennzahlen[jahr].auslastung
                ? kennzahlen[jahr].auslastung
                : 0;
            const erfasst = kennzahlen[jahr] && kennzahlen[jahr].erfasst
                ? kennzahlen[jahr].erfasst
                : '';
            const institution = kennzahlen[jahr] && kennzahlen[jahr].institution
                ? kennzahlen[jahr].institution
                : '';
            const row = [
                jahr,
                fn0nZ(beheizte_flaeche),
                fn0nZ(mitarbeiter),
                fn0nZ(umsatz),
                fn0nZ(auslastung),
                erfasst,
                institution
            ];
            if (!this.props.standortTid || isCfm) {
                row.splice(4, 1);
            }
            const row_length: number = row.length;
            const hasValues: boolean = rowHasValues(row);
            const isWebForced: boolean = !!(!hasValues && this.state.validation[jahr]);
            const d1 = { jahr, umsatz, auslastung };
            const d2 = { jahr, mitarbeiter };
            rows.push([
                <div data-text={row[0]}>
                    <div>{row[0]}</div>
                    {this.state.validation[jahr] &&
                        <ValidierungHinweise
                            entities={this.entities}
                            id={jahr}
                            showPriorityColors
                            validation={this.state.validation}
                        />
                    }
                </div>,
                ...(!hasValues && this.state.validation[jahr]
                    ? Array.from(Array(row_length - 1), (): void => null)
                    : [...Array(row_length - 1)].map((item: any, index: number) => row[index + 1])
                )
            ]);
            if (hasValues) {
                if (umsatz || auslastung) {
                    diag1.push(d1);
                }
                if (mitarbeiter) {
                    diag2.push(d2);
                }
            }
            custom_row_classes.push(isWebForced ? Array.from(Array(row_length), () => 'row_field') : undefined);
            row_web_forced.push(isWebForced);
        }
        return { rows, diag1, diag2, custom_row_classes, row_web_forced };
    }

    render(): JSX.Element {
        const color: any = SectionStyle.getSectionColors() || {};
        const lineColor = [
            color.datenauswertung || '#4f81bd', color.zusatztools || '#f79646', color.dateneingabe || '#87bd51', '#51bd75', '#5163bd',
            '#9951bd', '#bd5175', '#bd5151'
        ];
        // const style: any = { sub: getStyle('sub') };
        // const totalWidth = 13 * 60; // Das war die Ausgangsbasis
        const isCfm: boolean = (this.props.data || {}).MODUL_SELECTED === 'cfm';
        const numCols = 6 + 2 + ((!this.props.standortTid || isCfm) ? 0 : 1); // +2 weil die letzten beiden Spalten doppelt so breit werden sollen
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const values = this.getValues();
        const config: any = {
            titel0: unternehmen,
            titel1: i18n('Auswertung Betriebsdaten', 'sys'),
            titel2: this.props.standortName,
            filename: `${i18n('Auswertung', 'sys')}_${i18n('Betriebsdaten_', 'sys')}${this.state.firstJahr}_${this.state.lastJahr}.pdf`,
            report: { data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'betriebsdaten' },
            baseWidth: baseWidth,
            header: {
                title: i18n('Übersicht Berechnung', 'sys'),
                blocks: [
                    {
                        label: i18n('Jahr', 'sys'),
                        width: `${baseWidth}%`
                    },
                    {
                        label: i18n('Beheizte{{lb}}Fläche', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 'm²' }
                        ]
                    },
                    {
                        label: i18n('Anzahl{{lb}}Mitarbeitende', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 'n' }
                        ]
                    },
                    {
                        label: `${i18n('Jahresumsatz', 'sys')}\n(${i18n('netto', 'sys')})`,
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: '€' }
                        ]
                    },
                    {
                        label: i18n('Betriebliche{{lb}}Auslastung', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: '%' }
                        ]
                    },
                    {
                        label: i18n('Daten erfasst{{lb}}durch', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth * 2}%`
                    },
                    {
                        label: `${i18n('Institution / Unternehmen', 'sys')}\n(${i18n('Datenerfasser:in', 'sys')})`,
                        width: `${baseWidth * 2}%`
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header'],
            custom_row_classes: values.custom_row_classes,
            row_web_forced: values.row_web_forced,
            rows_width: [, , , , , baseWidth * 2, baseWidth * 2],
            diagrams: [
                {
                    title: `${i18n('Jahresumsatz', 'sys')} & ${i18n('Betriebliche Auslastung', 'sys')}`,
                    titlePdf: `${i18n('Jahresumsatz', 'sys')} & ${i18n('Betriebliche Auslastung', 'sys')}`,
                    legend: [`${i18n('Jahresumsatz', 'sys')} [€]`, `${i18n('Betriebliche Auslastung', 'sys')} [%]`],
                    unit: ['€', '%'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['umsatz', 'auslastung'],
                    data: values.diag1,
                    tickPeriod: [50, 50],
                    singleYAxis: false,
                    lineColor,
                    containerSize: { width: '90%' },
                    customTickFormatter: (idx: number, value: any): string => {
                        return formatNumber(value);
                    }
                },
                {
                    title: i18n('Anzahl Mitarbeitende', 'sys'),
                    titlePdf: i18n('Anzahl Mitarbeitende', 'sys'),
                    legend: [i18n('Anzahl Mitarbeitende', 'sys')],
                    unit: [''],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['mitarbeiter'],
                    data: values.diag2,
                    tickPeriod: [50, 50],
                    singleYAxis: false,
                    lineColor,
                    containerSize: { width: '90%' }
                }
            ]
        };

        if (!this.props.standortTid || isCfm) {
            config.header.blocks.splice(4, 1);
            config.row_classes.splice(4, 1);
            config.rows_width.splice(4, 1);
        }
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label='Datenauswertung - Hinweise'
                helpKey='datenauswertung_bwl'
                type='info'
                editBar
            />
        );

        const jahresauswahl: any = <DatenauswertungJahrauswahl
            jahrMin={this.state.jahrMin}
            jahrMax={this.state.jahrMax}
            jahrFirst={this.state.firstJahr}
            jahrLast={this.state.lastJahr}
            contextKey='datenauswertung'
            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
            renderClean={true}
            wrapClass={datenauswertungStyle.datenauswertungFormField}

        />;
        const arr_header_form_elements: any[] = [
            {
                elem: jahresauswahl,
                wrapClass: 'datenauswertungContentLeft',
                skipFormFieldWrapper: true
            },
            {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
        ];

        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahl
                            jahrMin={this.state.jahrMin}
                            jahrMax={this.state.jahrMax}
                            jahrFirst={this.state.firstJahr}
                            jahrLast={this.state.lastJahr}
                            contextKey='datenauswertung'
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>*/
                        }
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='betriebsdaten'
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const entities: string[] = this.entities.map((item: any) => item.entity);
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingEnergiedaten(this.props.data, this.props.standortTid, entities) || {})
                })}
            />
        );
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback(!!flags.hasBetriebsdaten);
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_BETRIEBSDATEN, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
